import React, { useEffect, useState } from "react";

import {
    getEmployees,
    getSalaryList,
    createSalary
} from "../api/salaryAPI";

export default function SalaryMaster() {

    const [employees, setEmployees] = useState([]);
    const [salaryList, setSalaryList] = useState([]);

    const [formData, setFormData] = useState({
        uid: "",
        salary_per_day: "",
        effective_from: "",
        description: ""
    });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {

        try {

            const empRes =
                await getEmployees();

            const salaryRes =
                await getSalaryList();

            setEmployees(empRes.data || []);
            setSalaryList(salaryRes.data || []);

        } catch (error) {

            console.error(error);

        }

    };

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]:
                e.target.value
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await createSalary(formData);

            alert(
                "Salary created successfully"
            );

            setFormData({
                uid: "",
                salary_per_day: "",
                effective_from: "",
                description: ""
            });

            loadData();

        } catch (error) {

            alert(
                error?.response?.data?.message ||
                "Unable to save salary"
            );

        }

    };

    return (

        <div className="p-4 bg-[var(--app-bg)] text-[var(--text)]">

            <h2 className="text-2xl font-bold mb-4 text-[var(--text)]">
                Salary Master
            </h2>

            <form
                onSubmit={handleSubmit}
                className="bg-[var(--surface-alt)] border border-[var(--border)] rounded p-4 mb-6"
            >

                <div className="grid grid-cols-4 gap-4">

                    <select
                        name="uid"
                        value={formData.uid}
                        onChange={handleChange}
                        className="border border-[var(--border)] bg-[var(--input-bg)] text-[var(--text)] p-2 rounded"
                        required
                    >
                        <option value="">
                            Select Employee
                        </option>

                        {employees.map(emp => (
                            <option
                                key={emp.uid}
                                value={emp.uid}
                            >
                                {emp.firstname} {emp.lastname}
                            </option>
                        ))}
                    </select>

                    <input
                        type="number"
                        name="salary_per_day"
                        placeholder="Salary Per Day"
                        value={
                            formData.salary_per_day
                        }
                        onChange={handleChange}
                        className="border border-[var(--border)] bg-[var(--input-bg)] text-[var(--text)] p-2 rounded"
                        required
                    />

                    <input
                        type="date"
                        name="effective_from"
                        value={
                            formData.effective_from
                        }
                        onChange={handleChange}
                        className="border border-[var(--border)] bg-[var(--input-bg)] text-[var(--text)] p-2 rounded"
                        required
                    />

                    <input
                        type="text"
                        name="description"
                        placeholder="Description"
                        value={formData.description}
                        onChange={handleChange}
                        className="border border-[var(--border)] bg-[var(--input-bg)] text-[var(--text)] p-2 rounded"
                    />

                </div>

                <button
                    type="submit"
                    className="
                    mt-4
                    px-4
                    py-2
                    bg-blue-600
                    text-white
                    rounded
                    "
                >
                    Save Salary
                </button>

            </form>

            <div className="bg-[var(--surface-alt)] border border-[var(--border)] rounded">

                <table className="w-full">

                    <thead>

                        <tr className="bg-[var(--surface-soft)]">

                            <th className="p-2">
                                Employee
                            </th>

                            <th className="p-2">
                                Salary/Day
                            </th>

                            <th className="p-2">
                                Effective From
                            </th>

                            <th className="p-2">
                                Active
                            </th>

                            <th className="p-2">
                                Description
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {salaryList.map(item => (

                            <tr
                                key={item.si_id}
                                className="border-t"
                            >

                                <td className="p-2">
                                    {item.employee_name}
                                </td>

                                <td className="p-2">
                                    ₹
                                    {item.salary_per_day}
                                </td>

                                <td className="p-2">
                                    {item.effective_from}
                                </td>

                                <td className="p-2">

                                    {
                                        item.is_active
                                            ? "Yes"
                                            : "No"
                                    }

                                </td>

                                <td className="p-2">
                                    {item.description}
                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>

    );

}